import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/images";

const ITEMS = [
  { src: IMAGES.gwagon, caption: "Protection céramique — fini miroir", span: "sm:col-span-2 sm:row-span-2", testid: "gallery-ceramique" },
  { src: IMAGES.reflection, caption: "Reflet après polissage correction", span: "", testid: "gallery-polissage" },
  { src: IMAGES.sedan, caption: "Finition cire haute performance", span: "", testid: "gallery-cire" },
  { src: IMAGES.polishing, caption: "Polissage machine en atelier", span: "", testid: "gallery-atelier" },
  { src: IMAGES.interior, caption: "Detailing intérieur complet", span: "sm:col-span-2", testid: "gallery-interieur" },
];

export const Gallery = () => (
  <section id="realisations" data-testid="gallery-section" className="py-28 lg:py-36 bg-white/[0.015] border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>Galerie de travail</Eyebrow>
        <h2 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl mb-16 max-w-2xl">
          Des résultats qui parlent <span className="gold-gradient-text">d'eux-mêmes</span>
        </h2>
      </Reveal>

      <div className="grid sm:grid-cols-3 auto-rows-[220px] sm:auto-rows-[240px] gap-5">
        {ITEMS.map((item, i) => (
          <Reveal key={item.testid} delay={i * 0.08} className={item.span}>
            <motion.figure
              data-testid={item.testid}
              whileHover="hover"
              className="group relative h-full w-full overflow-hidden rounded-xl border border-white/10 hover:border-gold/40 transition-[border-color] duration-500"
            >
              <motion.img
                src={item.src}
                alt={item.caption}
                loading="lazy"
                variants={{ hover: { scale: 1.06 } }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/35 transition-[background-color] duration-500" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-500">
                <span className="inline-block rounded-full bg-black/60 backdrop-blur-md border border-gold/30 px-4 py-1.5 text-xs uppercase tracking-[0.2em] text-gold">
                  {item.caption}
                </span>
              </figcaption>
            </motion.figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
